import React from 'react'
import classes from './ActiveQuiz.module.scss'
import AnswersList from "../AnswersList/AnswersList";

const ActiveQuiz = props =>(
    <div className={classes.ActiveQuiz}>
        <p className={classes.Question}>
            <span>
                <strong>{props.answerNumber}.</strong>&nbsp;
                {props.title}
            </span>
            <small>{props.answerNumber} из {props.quizLenght}</small>
        </p>
        <AnswersList
            answers = {props.answers}
            onAnswerClick = {props.onAnswerClick}
            state = {props.state}
        />
    </div>
)

export default ActiveQuiz